import styled from 'styled-components'
import Icon from './Icon'

const CheckIcon = styled(Icon).attrs({
  type: 'check',
})``

export default CheckIcon
